import { FilterTable } from "@/features/FilterTable/FilterTable";
import { Field } from "@/features/FilterTable/types";
import { preprocessTextAsyncAutocompleteField } from "@/features/FormCard/utils";
import { z } from "zod";
import { Clients } from "@/lib/clients";
import { Tables } from "@/gen/tableNames/tables";

// Zod schema for filter fields
export const filterGroupUsersSchema = z.object({
  client_contains: z
    .preprocess(preprocessTextAsyncAutocompleteField, z.string())
    .optional(),
  name_contains: z
    .preprocess(preprocessTextAsyncAutocompleteField, z.string())
    .optional(),
});

export type FilterGroupUsersSchema = z.infer<typeof filterGroupUsersSchema>;
const filterGroupUsersFields = filterGroupUsersSchema.keyof().enum;

// Configuration of the filter fields
export const fields: Field[] = [
  {
    name: filterGroupUsersFields.client_contains,
    label: "Client",
    type: "asyncAutocomplete",
    base_url: `${Clients.ADMIN_QUANTILIA}/${Tables.GROUP_USERS}`,
    column_name: "client",
  },
  {
    name: filterGroupUsersFields.name_contains,
    label: "Name",
    type: "asyncAutocomplete",
    base_url: `${Clients.ADMIN_QUANTILIA}/${Tables.GROUP_USERS}`,
    column_name: "name",
  },
];

export function FilterGroupUsers() {
  return (
    <FilterTable
      client={Clients.ADMIN_QUANTILIA}
      schema={filterGroupUsersSchema}
      tableName={Tables.GROUP_USERS}
      customBuildPath={() => `${Clients.QTL_USERS}/${Tables.GROUP_USERS}`}
      fields={fields}
    />
  );
}
